import(/* webpackMode: "eager", webpackExports: ["DocsSidebarNav"] */ "/vercel/path0/components/sidebar-nav.tsx");
